<template>
  <v-row v-if="sdaData">
    <v-col cols="12">
      <v-card>
        <v-card-title>
          Διαθέσιμα Προϊόντα ({{ filteredItems.length }}/{{ availableItems.length }})
        </v-card-title>
        <v-card-text>
          <div class="d-flex align-center">
            <v-text-field
              :value="search"
              @input="$emit('search-change', $event)"
              prepend-icon="mdi-magnify"
              label="Αναζήτηση"
              single-line
              hide-details
              class="flex-grow-1"
            />
            <v-btn icon @click="$emit('search-change', '')" v-if="search">
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </div>
        </v-card-text>
        <v-list>
          <SDAProductItem
            v-for="item in filteredItems"
            :key="item.PartnerMvItm_ID"
            :item="item"
            :selected-quantity="selectedItems[item.PartnerMvItm_ID] || 0"
            :disabled="isSDAExpired"
            :only-show-s-d-a-inv="onlyShowSDAInv"
            @info-click="$emit('info-click', $event)"
            @increment="$emit('increment', $event)"
            @decrement="$emit('decrement', $event)"
            @quantity-change="$emit('quantity-change', $event, arguments[1])"
          />
        </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import SDAProductItem from './SDAProductItem.vue'

export default {
  name: 'SDAProductList',
  components: {
    SDAProductItem
  },
  props: {
    sdaData: {
      type: Object,
      default: null
    },
    search: {
      type: String,
      default: ''
    },
    selectedItems: {
      type: Object,
      default: () => ({})
    },
    isSDAExpired: {
      type: Boolean,
      default: false
    },
    onlyShowSDAInv: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filteredItems() {
      if (!this.sdaData?.SDAInv?.SDAItems) return []
      return this.sdaData.SDAInv.SDAItems.filter(item => 
        item.AvailPosot > 0 && (
          item.ProductName.toLowerCase().includes(this.search.toLowerCase()) ||
          item.Product_ID.toLowerCase().includes(this.search.toLowerCase())
        )
      )
    },
    availableItems() {
      if (!this.sdaData?.SDAInv?.SDAItems) return [];
      return this.sdaData.SDAInv.SDAItems.filter(item => item.AvailPosot > 0);
    }
  }
}
</script> 